
































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import logger from "@/configs/logger";
import { objectify } from "../helpers";

@Component
export default class DialPad extends Vue {
  @Prop({ default: () => {} }) call!: Function;
  @Prop({ default: () => {} }) hangup!: Function;
  @State("taskAttributes") taskAttributes!: any;

  // @ts-ignore
  readonly connection: any = window._connection;
  readonly keys = [1, 2, 3, 4, 5, 6, 7, 8, 9, "*", 0, "#"];
  selectedKeys: string = "";
  mode: "dialtone" | "call" = "dialtone";
  inAddedCall: boolean = false;

  @Watch("taskAttributes")
  onTaskAttributeChange(val: any, prev: any) {
    const attr = objectify(val);
    const addedCalls = attr.added_calls_sids;
    if (Array.isArray(addedCalls) && addedCalls.length) {
      if (!this.inAddedCall) {
        this.inAddedCall = true;
      }
    } else {
      if (this.inAddedCall) {
        this.inAddedCall = false;
      }
    }
  }

  get title(): string {
    if (this.mode === "dialtone") {
      return "dialtone";
    }
    return "add a call";
  }

  get canDial(): boolean {
    return this.selectedKeys.length >= 10;
  }

  changeToCallMode() {
    this.selectedKeys = "";
    this.mode = "call";
  }

  changeToDialtoneMode() {
    this.selectedKeys = "";
    this.mode = "dialtone";
  }

  sendDigit(digit: string): void {
    try {
      if (this.mode === "dialtone") {
        if (!this.connection) {
          throw new Error("No connection to send digits");
        }
        this.connection.sendDigits(String(digit));
      }
    } catch (err) {
      logger("error", err);
    }
  }

  handleKeyPress(key: string): void {
    this.selectedKeys = this.selectedKeys + key;
    this.sendDigit(key);
  }

  handleBackspace(): void {
    if (this.selectedKeys.length) {
      this.selectedKeys = this.selectedKeys.substring(
        0,
        this.selectedKeys.length - 1
      );
    }
  }

  handleCall(): void {
    this.call(this.selectedKeys, () => {
      this.mode = "dialtone";
      this.inAddedCall = true;
    });
  }

  handleHanup(): void {
    this.hangup(() => {
      this.inAddedCall = false;
    });
  }
}
